"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupUsersCard = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const core_ui_1 = require("@sierralabs/core-ui");
const useFindUsers_1 = require("../../hooks/useFindUsers");
const GroupUserAssignDialog_1 = __importDefault(require("../dialogs/GroupUserAssignDialog"));
const useRemoveUsersFromGroup_1 = require("../hooks/useRemoveUsersFromGroup");
const StyledCard = (0, styled_components_1.default)(core_1.Card) `
  position: relative;
  .card-progress {
    top: 0;
    width: 100%;
    position: absolute;
  }
  .card-title {
    flex-wrap: wrap;
  }
  .title {
    flex: 1;
  }
  .actions {
    padding-top: 2px;
    padding-bottom: 2px;
  }
`;
const GroupUsersCard = (props) => {
    const { groupId, onRowClick } = props;
    const [page, setPage] = (0, react_1.useState)(0);
    const [limit, setLimit] = (0, react_1.useState)(100);
    const [order, setOrder] = (0, react_1.useState)('');
    const [direction, setDirection] = (0, react_1.useState)('DESC');
    const [openDialog, setOpenDialog] = (0, react_1.useState)(false);
    const [openConfirmDelete, setOpenConfirmDelete] = (0, react_1.useState)(false);
    const [users, setUsers] = (0, react_1.useState)([]);
    const [forRemoval, setForRemoval] = (0, react_1.useState)();
    const { data: userList, isLoading, error, get: findUsers } = (0, useFindUsers_1.useFindUsers)();
    const defaultLimit = 100;
    const hasMembers = users.length > 0;
    const { data: removedGroup, removeUsersFromGroup } = (0, useRemoveUsersFromGroup_1.useRemoveUsersFromGroup)(groupId);
    const handleSort = (column) => {
        setOrder(column);
        setDirection(direction === 'ASC' ? 'DESC' : 'ASC');
    };
    const getSortDirection = (column) => {
        return order === column && direction === 'DESC' ? 'desc' : 'asc';
    };
    const findUsersWithParams = (0, react_1.useCallback)(() => {
        findUsers({ page, limit, order, direction, groupIds: [groupId] });
    }, [page, limit, order, direction, groupId, findUsers]);
    (0, react_1.useEffect)(() => {
        findUsersWithParams();
    }, [findUsersWithParams]);
    (0, react_1.useEffect)(() => {
        userList && setUsers(userList.data);
    }, [userList]);
    (0, react_1.useEffect)(() => {
        if (removedGroup) {
            setOpenConfirmDelete(false);
            setForRemoval(undefined);
            findUsersWithParams();
        }
    }, [removedGroup, findUsersWithParams]);
    return (react_1.default.createElement(StyledCard, null,
        isLoading && react_1.default.createElement(core_1.LinearProgress, { className: 'card-progress' }),
        react_1.default.createElement(core_ui_1.CardTitle, null,
            react_1.default.createElement(icons_1.Group, null),
            react_1.default.createElement("div", { className: 'title' }, "Team Members"),
            react_1.default.createElement(core_1.Button, { size: 'small', color: 'primary', variant: 'outlined', onClick: () => setOpenDialog(true) }, "Add Employees")),
        react_1.default.createElement(core_1.TableContainer, null,
            react_1.default.createElement(core_1.Table, null,
                react_1.default.createElement(core_1.TableHead, null,
                    react_1.default.createElement(core_1.TableRow, null,
                        react_1.default.createElement(core_1.TableCell, null,
                            react_1.default.createElement(core_1.TableSortLabel, { active: order === 'id', direction: getSortDirection('id'), onClick: () => handleSort('id') }, "ID")),
                        react_1.default.createElement(core_1.TableCell, null,
                            react_1.default.createElement(core_1.TableSortLabel, { active: order === 'firstName', direction: getSortDirection('firstName'), onClick: () => handleSort('firstName') }, "First Name")),
                        react_1.default.createElement(core_1.TableCell, null,
                            react_1.default.createElement(core_1.TableSortLabel, { active: order === 'lastName', direction: getSortDirection('lastName'), onClick: () => handleSort('lastName') }, "Last Name")),
                        react_1.default.createElement(core_1.TableCell, null,
                            react_1.default.createElement(core_1.TableSortLabel, { active: order === 'email', direction: getSortDirection('email'), onClick: () => handleSort('email') }, "Email")),
                        react_1.default.createElement(core_1.TableCell, null, "Group/s"),
                        react_1.default.createElement(core_1.TableCell, { width: 1 }))),
                react_1.default.createElement(core_1.TableBody, null,
                    !hasMembers && (react_1.default.createElement(core_1.TableRow, null,
                        react_1.default.createElement(core_1.TableCell, { colSpan: 6 }, isLoading
                            ? 'Loading team members...'
                            : (error === null || error === void 0 ? void 0 : error.message) || 'No team members to show.'))),
                    users.map(user => {
                        var _a;
                        return (react_1.default.createElement(core_1.TableRow, { key: user.id, hover: !!onRowClick, onClick: () => onRowClick === null || onRowClick === void 0 ? void 0 : onRowClick(user) },
                            react_1.default.createElement(core_ui_1.WrappedTableCell, null,
                                "USER-",
                                user.id),
                            react_1.default.createElement(core_ui_1.WrappedTableCell, null, user.firstName),
                            react_1.default.createElement(core_ui_1.WrappedTableCell, null, user.lastName),
                            react_1.default.createElement(core_ui_1.WrappedTableCell, null, user.email),
                            react_1.default.createElement(core_ui_1.WrappedTableCell, null, (_a = user.groups) === null || _a === void 0 ? void 0 : _a.map(group => group.name).join(', ')),
                            react_1.default.createElement(core_1.TableCell, { className: 'actions' },
                                react_1.default.createElement(core_1.IconButton, { size: 'small', onClick: event => {
                                        event.stopPropagation();
                                        event.preventDefault();
                                        setForRemoval(user);
                                        setOpenConfirmDelete(true);
                                    } },
                                    react_1.default.createElement(icons_1.Close, null)))));
                    })))),
        react_1.default.createElement(core_1.TablePagination, { rowsPerPageOptions: [10, 25, 100], component: 'div', count: (userList === null || userList === void 0 ? void 0 : userList.total) || 0, rowsPerPage: (userList === null || userList === void 0 ? void 0 : userList.limit) || defaultLimit, page: (userList === null || userList === void 0 ? void 0 : userList.page) ? userList.page - 1 : 0, onPageChange: (_, newPage) => setPage(newPage), onRowsPerPageChange: event => {
                setLimit(+event.target.value);
                setPage(0);
            } }),
        react_1.default.createElement(GroupUserAssignDialog_1.default, { open: openDialog, groupId: groupId, onCancel: () => setOpenDialog(false), onAssign: () => {
                setOpenDialog(false);
                findUsersWithParams();
            } }),
        openConfirmDelete && forRemoval && (react_1.default.createElement(core_ui_1.ConfirmDialog, { open: openConfirmDelete, title: 'Confirm Removal', message: `Are you sure you want to remove ${forRemoval.firstName} ${forRemoval.lastName} from the team?`, confirmLabel: 'Remove', onCancel: () => {
                setOpenConfirmDelete(false);
                setForRemoval(undefined);
            }, onConfirm: () => {
                setOpenConfirmDelete(false);
                removeUsersFromGroup(forRemoval.id);
            } }))));
};
exports.GroupUsersCard = GroupUsersCard;
exports.default = exports.GroupUsersCard;
//# sourceMappingURL=GroupUsersCard.js.map